"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const httpRepository_1 = __importDefault(require("./httpRepository"));
const RequestRepository = {
    getRequestList: () => httpRepository_1.default.tradeshiftGo()
        .get('/rest/requests?archived=false')
        .then((response) => {
        return response.data;
    }),
    addTag: (options) => httpRepository_1.default.tradeshiftGo()
        .put(`/rest/requests/${options.requestId}/tags/${options.tag}`)
        .then(response => {
        return response.data;
    }),
    approve: (options) => httpRepository_1.default.tradeshiftGo()
        .post(`/rest/requests/${options.requestId}/approve`, options)
        .then(response => {
        return response.data;
    }),
    cancelRequest: (options) => httpRepository_1.default.tradeshiftGo()
        .delete(`/rest/requests/${options.requestId}`)
        .then(response => {
        return response.data;
    }),
    getRequest: (options) => {
        return httpRepository_1.default.tradeshiftGo()
            .get(`/rest/requests/${options.requestId}`)
            .then((response) => {
            return response.data;
        });
    },
    getRequests: (options = {}) => {
        const params = {};
        if (options.archived !== undefined) {
            params.archived = options.archived;
        }
        return httpRepository_1.default.tradeshiftGo()
            .get('/rest/requests', { params })
            .then(response => {
            return response.data;
        });
    },
    reject: (options) => {
        const data = {
            taskId: options.taskId,
        };
        return httpRepository_1.default.tradeshiftGo()
            .post(`/rest/requests/${options.requestId}/reject`, data)
            .then(response => {
            return response.data;
        });
    },
    registerRequest: (options) => {
        return httpRepository_1.default.tradeshiftGo()
            .post(`/rest/requests/${options.requestId}`)
            .then(response => {
            return response.data;
        });
    },
    removeTag: (options) => httpRepository_1.default.tradeshiftGo()
        .delete(`/rest/requests/${options.requestId}/tags/${options.tag}`)
        .then(response => {
        return response.data;
    }),
    submitRequest: (options) => httpRepository_1.default.tradeshiftGo()
        .post(`/rest/requests/${options.requestId}/submit`, options.data)
        .then(response => {
        return response.data;
    }),
    // IMPORTANT - this is NOT currently being used (supported a canceled feature)
    // PLEASE REMOVE this note if you decide to start using it
    // its purpose is to validate a particular value against a policy (a rule)
    validateRequest: (policyKey, policyValue) => httpRepository_1.default.tradeshiftGo()
        .get(`/rest/requests/validate/${policyKey}/${policyValue}`)
        .then(response => {
        return response.data;
    }),
};
exports.default = RequestRepository;
